module["exports"] = ["(####) ######", "##########", "06########", "06 #### ####"];